(() => {
  // Include anche le griglie Featured Collection
  const GRID_SEL = `
    .product-grid,
    .collection-products,
    .grid--products,
    .collection .grid,
    .collection-grid .grid
  `;
  const INFO_SEL = '.product-card__information__wrapper';
  const INFO_VISIBLE = '.product-card__information__wrapper:not(.product-card__information__wrapper--hide)';
  const PROMO_CARD = '.promotion-card';
  const PROMO_INNER = '.promotion-card__inner';
  const PROMO_TEXT = '.promotion-card__item-text';

  const debounce = (fn, ms = 100) => { let t; return (...a)=>{ clearTimeout(t); t=setTimeout(()=>fn(...a), ms);} };

  function equalizeGrid(grid) {
    const infos = grid.querySelectorAll(INFO_SEL);
    if (!infos.length) return;

    // reset
    infos.forEach(el => el.style.minHeight = '');
    let maxH = 0;

    // calcola altezza massima del box info visibile
    grid.querySelectorAll(INFO_VISIBLE).forEach(el => {
      maxH = Math.max(maxH, el.offsetHeight);
    });
    if (maxH === 0) infos.forEach(el => maxH = Math.max(maxH, el.offsetHeight));

    // applica min-height uniforme
    infos.forEach(el => el.style.minHeight = maxH + 'px');

    // === blocco aggiunto: uniforma promotion-card ===
    const promoCards = document.querySelectorAll(PROMO_CARD);
    const productCards = document.querySelectorAll('.product-card-wrapper.background-modal, .product-card');

    // reset promo
    promoCards.forEach(p => {
      p.style.height = '';
      const inner = p.querySelector(PROMO_INNER);
      if (inner) inner.style.height = '';
    });

    // trova altezza massima tra product cards e promotion cards
    const maxProductHeight = Math.max(...Array.from(productCards).map(c => c.offsetHeight || 0));
    const maxPromoHeight = Math.max(...Array.from(promoCards).map(c => c.offsetHeight || 0));
    const finalMaxHeight = Math.max(maxProductHeight, maxPromoHeight);

    // applica a tutte le promo
    promoCards.forEach(p => {
      p.style.height = finalMaxHeight + 'px';
      const inner = p.querySelector(PROMO_INNER);
      if (inner) inner.style.height = '100%';
      const text = p.querySelector(PROMO_TEXT);
      if (text) text.style.minHeight = maxH + 'px';
    });
  }

  function equalizeAll() {
    document.querySelectorAll(GRID_SEL).forEach(equalizeGrid);
  }

  const run = debounce(() => {
    requestAnimationFrame(() => {
      equalizeAll();
      setTimeout(equalizeAll, 120); // doppio pass per immagini lazy
    });
  }, 80);

  window.addEventListener('load', run, { passive: true });
  window.addEventListener('resize', run, { passive: true });
  document.addEventListener('DOMContentLoaded', run, { passive: true });

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(run);
  }

  // immagini/video
  document.addEventListener('DOMContentLoaded', () => {
    document
      .querySelectorAll(`${GRID_SEL} img, ${GRID_SEL} video, ${PROMO_CARD} img, ${PROMO_CARD} video`)
      .forEach(el => {
        const needs = (el.tagName === 'IMG' && !el.complete) ||
                      (el.tagName === 'VIDEO' && !(el.readyState > 2));
        if (needs) {
          el.addEventListener('load', run, { passive: true });
          el.addEventListener('loadeddata', run, { passive: true });
        }
      });
  });

  // Theme Editor support
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:section:select', run);
})();